import axiosInstance from './AxiosInstance';

export function getRoomTypes() {
    return axiosInstance.get(`/room-types`);
}

export function createRoomType(roomTypeData) {
    return axiosInstance.post(`/room-type`, roomTypeData);
}

export function updateRoomType(roomTypeData) {
    return axiosInstance.put(`/room-type/update`, roomTypeData);
}

export function deleteRoomType(roomTypeId) {
    return axiosInstance.delete(`/room-type/${roomTypeId}`);
}
